import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "close-rit"
}
const _hoisted_2 = {
  class: "content rounded-b-xl",
  style: {"padding":"20px 30px 20px 30px"}
}
const _hoisted_3 = {
  class: "flex w-full items-center justify-end",
  style: {"padding":"0px 5px 8px 5px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-2xl font-extrabold" }, "Akhiri RIT?"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xl text-grey font-normal" }, "Lengkapi semua data pengeluaran sebelum mengakhiri RIT!")
], -1)
const _hoisted_5 = { class: "mt-20px" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Kondektur", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "flex items-center gap-4 mt-3" }
const _hoisted_9 = { class: "w-full md:w-1/2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Sopir", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "w-full md:w-1/2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Pembantu", -1)
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "mt-20px" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-bold" }, "Daftar Pengeluaran", -1)
const _hoisted_17 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_18 = { class: "label-text required" }
const _hoisted_19 = { class: "mt-20px" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-bold" }, "Pendapatan Lain-lain", -1)
const _hoisted_21 = { class: "flex items-center gap-4" }
const _hoisted_22 = { class: "w-full md:w-1/2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nominal Rombongan Drop", -1)
const _hoisted_24 = { class: "w-full md:w-1/2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Jumlah Rombongan Drop", -1)
const _hoisted_26 = { class: "mt-20px" }
const _hoisted_27 = { class: "flex items-center gap-4" }
const _hoisted_28 = { class: "w-full md:w-1/2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nominal Pendapatan Tiket Manual", -1)
const _hoisted_30 = { class: "w-full md:w-1/2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Jumlah Tiket Manual", -1)
const _hoisted_32 = { class: "flex items-center mt-50" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "",
          showHeader: false,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '60vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: "pi pi-times cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
                  })
                ])
              ]),
              _createVNode(_component_Form, {
                onSubmit: $setup.onSubmit,
                "initial-values": $setup.initialValue,
                "validation-schema": $setup.schema,
                validateOnMount: false
              }, {
                default: _withCtx(({ errors, values, setFieldValue, meta }) => [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", null, [
                      _createVNode(_component_Field, {
                        class: "w-full input-default",
                        type: "text",
                        name: "condecturName"
                      }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            class: `input-primary`,
                            placeholder: "Nama Kondektur",
                            autocomplete: "off",
                            maxlength: 50,
                            readonly: true
                          }), null, 16)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(errors.condecturName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_Field, {
                          class: "w-full input-default",
                          type: "text",
                          name: "driverName"
                        }, {
                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              placeholder: "Nama Sopir",
                              autocomplete: "off",
                              maxlength: 50
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(errors.driverName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_Field, {
                          class: "w-full input-default",
                          type: "text",
                          name: "helperName"
                        }, {
                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              placeholder: "Nama Pembantu",
                              autocomplete: "off",
                              maxlength: 50
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(errors.helperName), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ritExpenses, (data) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: data,
                            class: "w-full"
                          }, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(data.Name), 1),
                            _createVNode(_component_InputNumber, {
                              class: "w-full default-input",
                              modelValue: data.Value,
                              "onUpdate:modelValue": ($event: any) => ((data.Value) = $event),
                              placeholder: "0",
                              min: 0,
                              max: 99999999.99,
                              step: 0.25
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "step"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_InputNumber, {
                            class: "w-full default-input",
                            modelValue: $setup.otherRevenues.nominalRombonganDrop,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.otherRevenues.nominalRombonganDrop) = $event)),
                            placeholder: "0",
                            min: 0,
                            max: 99999999.99,
                            step: 0.25
                          }, null, 8, ["modelValue", "max", "step"])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(_component_InputNumber, {
                            class: "w-full default-input",
                            modelValue: $setup.otherRevenues.jumlahRombonganDrop,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.otherRevenues.jumlahRombonganDrop) = $event)),
                            placeholder: "0",
                            min: 0,
                            max: 99999999.99,
                            step: 0.25
                          }, null, 8, ["modelValue", "max", "step"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_InputNumber, {
                            class: "w-full default-input",
                            modelValue: $setup.otherRevenues.nominalTiketManual,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.otherRevenues.nominalTiketManual) = $event)),
                            placeholder: "0",
                            min: 0,
                            max: 99999999.99,
                            step: 0.25
                          }, null, 8, ["modelValue", "max", "step"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_InputNumber, {
                            class: "w-full default-input",
                            modelValue: $setup.otherRevenues.jumlahTiketManual,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.otherRevenues.jumlahTiketManual) = $event)),
                            placeholder: "0",
                            min: 0,
                            max: 99999999.99,
                            step: 0.25
                          }, null, 8, ["modelValue", "max", "step"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Button, {
                      class: "btn-back mr-2",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.closeDialog()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      type: "submit",
                      class: "btn-primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "initial-values", "validation-schema"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_HjpConfirmationModal, {
          show: $setup.attrModalConfirmation.show,
          imgContent: $setup.attrModalConfirmation.imgContent,
          title: $setup.attrModalConfirmation.title,
          subTitle: $setup.attrModalConfirmation.subTitle,
          btnSubmitTitle: $setup.attrModalConfirmation.btnSubmitTitle,
          onHideDialog: $setup.hideConfirmCloseRitDialog,
          onOnSubmit: $setup.progressCloseRit
        }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
      ]))
    : _createCommentVNode("", true)
}